import styled from "styled-components/macro";
import { Heading5Css } from "styles/elements/Headings";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
  submitted?: boolean;
  currentQuestion?: number;
}

export const StyleVideo = styled.div<Props>`
min-width: 600px;
margin: 0 10px;
figure {
  margin-left: 0;
  margin-bottom: 30px;
  width: 600px;
}
.pl-title {
  ${Heading5Css};
  display: none;
}
.pl-paragraph {
  display: none;
}
.pl-particle {
  margin-bottom: 0;
}
.pl-video {
  margin-bottom: 0;
}
.plyr__caption {
  white-space: inherit;
  font-size: 1rem;
}
`;

export const StyleDiv = styled.div<Props>`
  max-width: 600px;
  margin: 0 auto
`;

export const StyleAudioFile = styled.div<Props>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  top: -30px;
  figcaption {
    display: none;
  }
  .pl-audio-button {
    width: 92px;
    height: 115px;
    &:hover {
      background-color: ${(props: Props) => props.theme.palette.neutral._00};
      border: 2px solid ${(props: Props) => props.theme.palette.neutral._00};
    }
    svg {
      color: ${(props: Props) => props.theme.palette.neutral._20};
      fill: ${(props: Props) => props.theme.palette.neutral._20};
    }
  }
`;
